module.exports = __webpack_public_path__ + "static/media/header-small.7803ba8d.jpg";